import Engine from "../base/engine";
import CartAddAction from "./cart.add";
import CartAttributesAction from "./cart.attributes";
import CartDiscountAction from "./cart.discount";

class ActionsEngine extends Engine {
  name = "ActionsEngine";
  
  constructor() {
    super();
  }

  /**
   * Execute the actions of this engine and evaluate them against the data.
   * 
   * @param {Object} data 
   * @returns {Promise<boolean>}
   */
  async execute(data) {
    let result = true;
    for await (const component of this.components) {
      try {
        // result &&= is a short-circuiting operation. The &&= operator checks the
        // value of result before evaluating the right-hand side. If result is 
        // false, it skips the right-hand side entirely, so the await may not be hit at all.
        let componentResult = await component.execute(data);
        result &&= componentResult;
      } catch (e) {
        console.error(component.logPrefix, `Failed to execute action -`, e.message);
        result = false;
      }
    }
    return result;
  }

  /**
   * Undo the actions of this engine if birirectional specified.
   * 
   * @param {Object} data 
   * @returns {Promise<boolean>}
   */
  async undo(data) {
    let result = true;
    for await (const component of this.components) {
      if(component.config.bidirectional){
        let componentResult = await component.undo(data);
        result &&= componentResult;
      }
    }
  return result;
  }

  /**
   * Describe the engine in the console.
   */
  async explain() {
    console.group("🎯 Then...");
    for await (const component of this.components) {
      let explanation = await component.explainAction();
      console.log(`• ${explanation}`);
    }
    console.groupEnd();
    console.group("↩️ Otherwise...");
    for await (const component of this.components) {
      let explanation = await component.explainUndo();
      if(explanation) console.log(`• ${explanation}`);
    }
    console.groupEnd();
  }

  /**
   * Static method to create an action from a JS object or JSON string. Needs to
   * be here (rather than in the Action class) to avoid circular dependencies.
   */
  static fromJSON(json) {
    if (typeof json === 'string') {
      json = JSON.parse(json);
    }
    switch(json.type) {
      case "cart.add":
        return new CartAddAction(json.config);
      case "cart.attributes":
        return new CartAttributesAction(json.config);
      case "cart.discount":
        return new CartDiscountAction(json.config);
    }

    throw new Error(`[A/E] Unknown action type: ${json.type}`);
  }
}

export default ActionsEngine;